// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".remark-height[data-v-5233fbbc] {\n  height: 1px;\n}", ""]);
// Exports
module.exports = exports;
